var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',{staticClass:"brand main-margin"},[_vm._v("Moogle!")]),_c('Searcher')],1)}
var staticRenderFns = []

export { render, staticRenderFns }